import SelectDropdown from "../../../shared/components/SelectDropdown";
import { buildSelectOptions } from "../formatters";

export function FilterCard({
  label,
  value,
  options,
  onChange,
  isMulti = false,
  disabled = false,
  isLoading = false,
  placeholder,
}) {
  const selectedOption = isMulti
    ? value.map((item) => ({ label: item, value: item }))
    : value
      ? { label: value, value }
      : null;

  return (
    <label className="flex flex-col gap-2">
      <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#7d92b2]">
        {label}
      </span>
      <SelectDropdown
        options={buildSelectOptions(options)}
        value={selectedOption}
        onChange={onChange}
        isMulti={isMulti}
        isDisabled={disabled}
        isLoading={isLoading}
        isClearable
        placeholder={placeholder}
      />
    </label>
  );
}
